<template>
  <div>
    <!-- 付款表单 -->
    <el-dialog :title="payFormTitle" :visible="visible" :show-close="false">
      <el-form label-width="200px" class="pay-form">
        <el-form-item label="用车时间:">
          {{ payInfo.start_time }}&nbsp;~&nbsp;{{ payInfo.end_time && payInfo.end_time.substr(11) }}&nbsp;&nbsp;(<strong>{{ payInfo.use_time }}</strong>分钟)
        </el-form-item>
        <el-form-item label="费用:">
          {{ payInfo.price_type }}
          <span v-if="payInfo.price_type === '按小时计费'">
            {{ Math.ceil(payInfo.use_time / 60) }}&nbsp;*&nbsp;{{ payInfo.price }}&nbsp;=&nbsp;
          </span>
          <span v-if="payInfo.price_type === '按分钟计费'">
            {{ payInfo.use_time }}&nbsp;*&nbsp;{{ payInfo.price }}&nbsp;=&nbsp;
          </span>
          <strong>{{ payInfo.fee }}</strong>元<br/>
          保底消费<strong>{{ payInfo.min_fee }}</strong>元&nbsp;<el-button type="text" @click="editMinFee">修改</el-button><br/>
          优惠<strong>{{ payInfo.fee_discount }}</strong>元&nbsp;<el-button type="text" @click="editFeeDiscount">修改</el-button><br/>
          应收<strong style="font-size:16px;">{{ reallyFee }}</strong>元，实收<strong>{{ payInfo.pay_total }}</strong>元
        </el-form-item>
        <el-form-item label="现金支付:" v-if="payInfo.pay_cash > 0">
          {{ payInfo.pay_cash }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_cash')">删除</el-button>
        </el-form-item>
        <el-form-item label="支付宝:" v-if="payInfo.pay_alipay > 0">
          {{ payInfo.pay_alipay }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_alipay')">删除</el-button>
        </el-form-item>
        <el-form-item label="微信支付:" v-if="payInfo.pay_wechat > 0">
          {{ payInfo.pay_wechat }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_wechat')">删除</el-button>
        </el-form-item>
        <el-form-item label="银行卡支付:" v-if="payInfo.pay_pos > 0">
          {{ payInfo.pay_pos }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_pos')">删除</el-button>
        </el-form-item>
        <el-form-item v-for="card in payCards" :key="card.id" :label="'充值卡(' + card.card_no_short + ')支付:'">
          {{ card.oper_money }}元&nbsp;&nbsp;<el-button type="text" @click="deleteCardPay(card)">删除</el-button>
        </el-form-item>
        <el-form-item v-for="coupon in payCoupons" :key="coupon.id" :label="'代金券(' + coupon.coupon_no_short + ')支付:'">
          {{ coupon.coupon_money }}元&nbsp;&nbsp;<el-button type="text" @click="deleteCouponPay(coupon)">删除</el-button>
        </el-form-item>
        <el-form-item label="挂账:" v-if="payInfo.pay_virtual > 0">
          {{ payInfo.pay_virtual }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_virtual')">删除</el-button>
        </el-form-item>
        <el-form-item label="预收:" v-if="payInfo.pay_advance > 0">
          {{ payInfo.pay_advance }}元&nbsp;&nbsp;<el-button type="text" @click="deletePay('pay_advance')">删除</el-button>
        </el-form-item>
        <el-form-item>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="cursor:pointer;color:#409eff;">
              +添加支付方式<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="payInfo.pay_cash == 0" command="pay_cash">现金支付</el-dropdown-item>
              <el-dropdown-item v-if="payInfo.pay_alipay == 0" command="pay_alipay">支付宝</el-dropdown-item>
              <el-dropdown-item v-if="payInfo.pay_wechat == 0" command="pay_wechat">微信支付</el-dropdown-item>
              <el-dropdown-item v-if="payInfo.pay_pos == 0" command="pay_pos">银行卡支付</el-dropdown-item>
              <el-dropdown-item command="pay_balance">充值卡支付</el-dropdown-item>
              <el-dropdown-item command="pay_coupon">代金券支付</el-dropdown-item>
              <el-dropdown-item v-if="payInfo.pay_virtual == 0 && user.pay_virtual == '1'" command="pay_virtual">挂账</el-dropdown-item>
              <el-dropdown-item v-if="payInfo.pay_advance == 0 && user.pay_advance == '1'" command="pay_advance">预收</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!payInfoLoading">
        <div>
          <el-button type="primary" @click="payCommit">确 定</el-button>
          <el-button @click="payClose">稍后结算</el-button>
        </div>
        <div role="alert" class="el-alert el-alert--info" style="margin-top:10px;justify-content:flex-end;">
          <div class="el-alert__content">
            <span class="el-alert__title">提示:在账单记录中点击“结算”按钮可以打开本窗口</span>
          </div>
        </div>
      </div>
    </el-dialog>
    <pay-card-dialog :visible="payCardDialogVisible" :bill-id="billId" :fee="reallyFee" @commit="payCardCommit" @cancel="payCardCancel"></pay-card-dialog>
    <pay-coupon-dialog :visible="payCouponDialogVisible" :bill-id="billId" :company-id="payInfo.company_id" @commit="payCouponCommit" @cancel="payCouponCancel"></pay-coupon-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import PayCardDialog from './PayCardDialog'
import PayCouponDialog from './PayCouponDialog'
export default {
  components: {
    PayCardDialog,
    PayCouponDialog
  },
  props: {
    user: Object,
    billId: {
      type: Number,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      payFormTitle: '结算',
      payInfo: {
        /*
        id: 0,
        company_name: '',
        car_alias: '',
        licnum: '',
        coach_name: '',
        school_name: '',
        start_time: '',
        end_time: '',
        use_time: 0,
        price: 0,
        price_type: '',
        fee: 0,
        min_fee: 0,
        yajing: 0,
        fee_discount: 0
        */
      },
      payCards: [],
      payCoupons: [],
      payInfoLoading: false,
      payCardDialogVisible: false,
      payCouponDialogVisible: false
    }
  },
  computed: {
    reallyFee () {
      let fee = this.payInfo.fee
      if (this.payInfo.min_fee > this.payInfo.fee) {
        fee = this.payInfo.min_fee
      }
      return fee - this.payInfo.fee_discount
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.getBill()
        this.autoPayCoupon()
      }
    }
  },
  methods: {
    getBill () {
      this.payFormTitle = '正在加载结算信息...'
      this.payInfoLoading = true
      this.$http.get('/dbapi/bill_pay_info?id=' + this.billId).then(response => {
        if (response.data.success) {
          this.payInfoLoading = false
          this.payInfo = response.data.list[0]
          this.payFormTitle = `结算: ${this.payInfo.company_name} / ${this.payInfo.car_alias}
          / ${this.payInfo.school_name} / ${this.payInfo.coach_name}`
          this.payCards = []
          if (this.payInfo.pay_balance > 0) {
            this.$http.get('/dbapi/bill_pay_cards?id=' + this.billId).then(response => {
              this.payCards = response.data.list
            })
          }
          this.payCoupons = []
          if (this.payInfo.pay_coupon > 0) {
            this.$http.get('/dbapi/bill_pay_coupons?id=' + this.billId).then(response => {
              this.payCoupons = response.data.list
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    autoPayCoupon () { // 自动使用学员代金券
      this.$http.get('/dbapi/coupon_unused?bill_id=' + this.billId).then(response => {
        if (response.data.success) {
          if (response.data.list.length > 0) {
            let coupon_nos = response.data.list.map(r => r.coupon_no)
            let money = 0
            for (var i = 0; i < response.data.list.length; i++) {
              money += response.data.list[i].coupon_money
            }
            this.$http.post('/dbapi/add_pay_coupons', {
              id: this.billId,
              money: money,
              coupon_nos: coupon_nos
            }).then(response => {
              this.getBill()
            })
          }
        }
      })
    },
    editMinFee () {
      this.$prompt(`请输入保底消费金额`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[0-9]\d*/,
        inputErrorMessage: '格式错误'
      }).then(({ value }) => {
        this.$http.post(`/dbapi/update_min_fee`, {
          id: this.billId,
          min_fee: value
        }).then(response => {
          if (response.data.success) {
            this.getBill()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    editFeeDiscount () {
      this.$prompt(`请输入优惠金额`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[0-9]\d*/,
        inputErrorMessage: '格式错误'
      }).then(({ value }) => {
        this.$http.post(`/dbapi/update_fee_discount`, {
          id: this.billId,
          fee_discount: value
        }).then(response => {
          if (response.data.success) {
            this.getBill()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    handleCommand (field) {
      let label = ''
      switch (field) {
        case 'pay_cash':
          label = '现金支付'
          break
        case 'pay_alipay':
          label = '支付宝'
          break
        case 'pay_wechat':
          label = '微信支付'
          break
        case 'pay_pos':
          label = '银行卡支付'
          break
        case 'pay_balance':
          label = '充值卡支付'
          break
        case 'pay_coupon':
          label = '代金券支付'
          break
        case 'pay_virtual':
          label = '挂账'
          break
        case 'pay_advance':
          label = '预收'
          break
      }
      if (field === 'pay_balance') {
        this.payCardDialogVisible = true
      } else if (field === 'pay_coupon') {
        this.payCouponDialogVisible = true
      } else {
        this.$prompt(`请输入${label}金额`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9]\d*/,
          inputErrorMessage: '格式错误'
        }).then(({ value }) => {
          this.$http.post(`/dbapi/add_${field}`, {
            id: this.billId,
            money: value
          }).then(response => {
            this.getBill()
            if (!response.data.success) {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        })
      }
    },
    deletePay (field) {
      this.payInfo[field] = 0
      this.$http.post(`/dbapi/del_${field}`, {
        id: this.billId
      }).then(response => {
        this.getBill()
        if (!response.data.success) {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    deleteCardPay (card) {
      this.$http.post(`/dbapi/del_pay_balance`, {
        id: this.billId,
        card_id: card.id,
        money: card.oper_money
      }).then(response => {
        this.getBill()
        if (!response.data.success) {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    deleteCouponPay (coupon) {
      this.$http.post(`/dbapi/del_pay_coupon`, {
        id: this.billId,
        coupon_id: coupon.id,
        money: coupon.coupon_money
      }).then(response => {
        this.getBill()
        if (!response.data.success) {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    payCommit () {
      if (this.reallyFee != this.payInfo.pay_total) {
        this.$message({
          type: 'error',
          message: '应收金额与实收金额不一致,请检查'
        })
        return
      }
      this.$http.post('/dbapi/bill_pay_confirm', {
        id: this.billId
      }).then(response => {
        if (response.data.success) {
          this.$emit('confirm', this.payInfo)
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    payClose () {
      this.$emit('cancel')
    },
    payCardCommit () {
      this.getBill()
      this.payCardDialogVisible = false
    },
    payCardCancel () {
      this.payCardDialogVisible = false
    },
    payCouponCommit () {
      this.getBill()
      this.payCouponDialogVisible = false
    },
    payCouponCancel () {
      this.payCouponDialogVisible = false
    }
  }
}
</script>

<style>
.pay-form .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/PayDialog.vue